import { render, staticRenderFns } from "./CambiarContrasena.vue?vue&type=template&id=60b8cc04&scoped=true&"
import script from "./CambiarContrasena.vue?vue&type=script&lang=js&"
export * from "./CambiarContrasena.vue?vue&type=script&lang=js&"
import style0 from "./CambiarContrasena.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CambiarContrasena.vue?vue&type=style&index=1&lang=css&"
import style2 from "./CambiarContrasena.vue?vue&type=style&index=2&id=60b8cc04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b8cc04",
  null
  
)

export default component.exports